module.exports = __webpack_public_path__ + "images/common/ico-info_135388c2f5e312e141e3a3ba6658b33a.png";